/* @flow strict */
import { emailRegexp } from '/client/src/constants/';

export const validateInput = (elWrapper: any, value: string | null, elWrapperConfirm: any, confirm_value: string | null): boolean => {
  
  if (!_.size(value)) {
    elWrapper.classList.add('has-error');
    elWrapper.querySelector('input').classList.add('validationElement');
    return false;
  }
  const checkInput = elWrapper.getElementsByTagName("input")[0];
  const isEmailValidation = checkInput && checkInput.hasAttribute("type") && checkInput.getAttribute("type") === "email";
  
  if(isEmailValidation){
    const isEmailNotValid =  !emailRegexp.test(value);
    if(isEmailNotValid){
      let messageElement = elWrapper.getElementsByClassName('validationMessage')[0];
      if(messageElement){
        messageElement.innerText = "Please enter a proper email address.";
      }
      elWrapper.classList.add('has-error');
      elWrapper.querySelector('input').classList.add('validationElement');
      return false;
    }
  }

  const isPasswordValidation = (checkInput && checkInput.hasAttribute("type") && (checkInput.getAttribute("type") === "password")) 
                              || checkInput.classList.contains("js_password_check")
  if(isPasswordValidation && _.size(confirm_value)){

    const isPasswordValid = value === confirm_value;
    if(!isPasswordValid)
    {
      let confirmPassMsgElement = elWrapperConfirm.getElementsByClassName('validationMessage')[0];
        if(confirmPassMsgElement){
        confirmPassMsgElement.innerText = "New Password fields must match.";
      }
      elWrapperConfirm.classList.add('has-error');
      elWrapperConfirm.querySelector('input').classList.add('validationElement');
      return false;
    }
    else {
      return true;
    }
  }
  elWrapper.classList.remove('has-error');
  elWrapper
    .querySelector('input')
    .classList
    .remove('validationElement');

  return true;
};
